export default __webpack_public_path__ + "static/media/hht2_ep15_speaking_01.e6ca25b4.png";